export const API_ENDPOINTS = {
  RULE: {
    FETCH: '/rule/fetch',
    SEARCH: '/rule/search',
    GET: '/rule/get',
    GETALL: '/rule/getall',
    CREATE: '/rule/create',
    UPDATE: '/rule/update',
    DELETE: '/rule/delete',
    GETRISKATTRIBUTE: '/rule/get-risk-attribute'
  },
  RULESET: {
    FETCH: '/ruleset/fetch',
    SEARCH: '/ruleset/search',
    GETALL: '/ruleset/getall',
    GET: '/ruleset/get',
    CREATE: '/ruleset/create',
    UPDATE: '/ruleset/update',
    DELETE: '/ruleset/delete'
  },
  NODE: {
    GET: '/node/get',
    GET_BY_NODE_ID: '/node/getbynodeid',
    UPDATE: '/node/update',
    DELETE: '/node/delete',
    CREATE: '/node/create',
    SAVE: '/node/save'
  },
  ASSET: {
    FETCH: '/asset/fetch',
    GET: '/asset/get',
    CREATE: '/asset/create',
    UPDATE: '/asset/update',
    DELETE: '/asset/delete',
    SEARCH: '/asset/search',
    FETCHREMACCESSFLOWASSETS: '/asset/fetchremainingassetsaccessflow',
    SEARCHREMACCESSFLOWASSETS: '/asset/searchremainingassetsaccessflow',
    GENERATEREMAININGASSETSACCESSFLOW: '/asset/generateremainingassetsaccessflow'
  },
  ACCESS_FLOW_RULESET: {
    FETCH: '/accessflowruleset/fetch',
    GET: '/accessflowruleset/get',
    GET_BY_ACCESS_FLOW_ID: '/accessflowruleset/getaccessflow',
    CREATE: '/accessflowruleset/create',
    UPDATE: '/accessflowruleset/update',
    DELETE: '/accessflowruleset/delete'
  },
  ACCESS_FLOW: {
    FETCH: '/accessflow/fetch',
    SEARCH: '/accessflow/search',
    GET: '/accessflow/get',
    CREATE: '/accessflow/create',
    UPDATE: '/accessflow/update',
    DELETE: '/accessflow/delete',
    GETNODES: '/accessflow/getnodes',
    ADD: '/accessflow/add',
    UPDATENODES: '/accessflow/updatenodes',
    FINISH: '/accessflow/finish',
    GENERATE: '/accessflow/generate',
    CHECK: '/accessflow/check'
  },
  ADAPTIVEACCESSCONTROLNODE: {
    FETCH: '/adaptiveaccesscontrolnode/fetch',
    SEARCH: '/adaptiveaccesscontrolnode/search',
    GET: '/adaptiveaccesscontrolnode/get',
    GETNODES: '/adaptiveaccesscontrolnode/getnodes',
    CREATE: '/adaptiveaccesscontrolnode/create',
    UPDATE: '/adaptiveaccesscontrolnode/update',
    DELETE: '/adaptiveaccesscontrolnode/delete',
    FINISH: '/adaptiveaccesscontrolnode/finish'
  },
  ADAPTIVEACCESSCONTROLNODECONF: {
    FETCH: '/adaptiveaccesscontrolnodeconf/fetch',
    GET: '/adaptiveaccesscontrolnodeconf/get',
    CREATE: '/adaptiveaccesscontrolnodeconf/create',
    UPDATE: '/adaptiveaccesscontrolnodeconf/update',
    DELETE: '/adaptiveaccesscontrolnodeconf/delete',
    ADD: '/adaptiveaccesscontrolnodeconf/add',
    UPDATENODES: '/adaptiveaccesscontrolnodeconf/updatenodes',
    GETNODES: '/adaptiveaccesscontrolnodeconf/getnodes'
  },
  ADAPTIVE_ACCESS_NODE_RULESET: {
    FETCH: '/adaptiveaccessnoderuleset/fetch',
    GET: '/adaptiveaccessnoderuleset/get',
    GET_BY_ADAPTIVE_ACCESS_NODE__ID: '/adaptiveaccessnoderuleset/getadaptiveaccessnode',
    CREATE: '/adaptiveaccessnoderuleset/create',
    CREATEFORUPDATE: '/adaptiveaccessnoderuleset/createforupdate',
    UPDATE: '/adaptiveaccessnoderuleset/update',
    DELETE: '/adaptiveaccessnoderuleset/delete',
    DELETESTAGE: '/adaptiveaccessnoderuleset/deletestage',
    FETCHSTAGE: '/adaptiveaccessnoderuleset/fetchstage',
  },
  PRINCIPALTYPE: {
    FETCH: '/principaltype/fetch'
  }
  ,
  DASHBOARD: {
    FETCH: '/adaptiveaccesscontrol/getdashboarddata',
    FETCHCHARTDATA: '/adaptiveaccesscontrol/getdashboardchartdata'
  },
  REPORT: {
    FETCH: '/adaptiveaccesscontrol/getreportsdata'
  }
};
